module.exports = __webpack_public_path__ + "img/header-melanie-blake.387f0620.jpg";